import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/accessibility-mac.vue
var o = {
	name: "DtIconAccessibilityMac",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--accessibility-mac"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Accessibility Mac",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1A5 5 0 1 0 6 1a5 5 0 0 0 0 10Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6.535 6.435c.033.153.106.375.195.62a33.864 33.864 0 0 0 .614 1.52l-.663.289L6 7.394l-.722 1.468-.33-.144-.329-.143.003-.006a33.237 33.237 0 0 0 .624-1.547c.083-.232.15-.441.182-.587.013-.052.024-.127.034-.214.007-.058.013-.122.018-.187.014-.174.024-.363.031-.502v-.007a124.85 124.85 0 0 1 .002-.04l.002-.032a.166.166 0 0 0-.058-.148.193.193 0 0 0-.066-.039l-1.53-.46a.36.36 0 0 1-.249-.46c.058-.174.245-.261.422-.232a.411.411 0 0 1 .033.007l.005.001a18.808 18.808 0 0 0 .493.148 11.779 11.779 0 0 0 1.07.262c.073.013.141.023.203.03a1.332 1.332 0 0 0 .283-.001 3.11 3.11 0 0 0 .228-.035 11.587 11.587 0 0 0 1.193-.305 18.849 18.849 0 0 0 .373-.115c.184-.041.387.07.436.252a.374.374 0 0 1-.249.448l-1.53.46a.17.17 0 0 0-.06.036.203.203 0 0 0-.064.15l.001.033a5.593 5.593 0 0 0 .002.038v.009c.002.017.002.036.003.055a15.544 15.544 0 0 0 .031.473c.013.153.03.293.05.375Zm.156-3.013a.697.697 0 1 0-1.382.18.697.697 0 0 0 1.382-.18Zm-1.413 5.44-.33-.144-.329-.143a.372.372 0 0 0 .323.522.337.337 0 0 0 .324-.211l.012-.024Zm1.403.002.662-.29a.358.358 0 0 1-.174.485.331.331 0 0 1-.15.038.359.359 0 0 1-.322-.199l-.016-.034Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=accessibility-mac.js.map